export const services = [
  {
    id: 'trademark-registration',
    title: 'Trademark Registration',
    icon: 'Shield',
    description: 'Secure your brand identity with comprehensive trademark registration services.',
    link: '/services/trademark-registration'
  },
  {
    id: 'copyright-registration',
    title: 'Copyright Registration',
    icon: 'FileText',
    description: 'Protect your creative works and intellectual property with official copyright registration.',
    link: '/services/copyright-registration'
  },
  {
    id: 'company-formation',
    title: 'Company Formation',
    icon: 'Building',
    description: 'Start your business with expert company formation and incorporation services.',
    link: '/services/company-formation'
  },
  {
    id: 'trademark-search',
    title: 'Comprehensive Trademark Search',
    icon: 'Search',
    description: 'Ensure your trademark is available with thorough search and analysis.',
    link: '/services/trademark-search'
  },
  {
    id: 'amazon-brand-registry',
    title: 'Amazon Brand Registry',
    icon: 'ShoppingCart',
    description: 'Protect your brand on Amazon with our specialized brand registry assistance.',
    link: '/services/amazon-brand-registry'
  }
];

export const testimonials = [
  {
    name: 'Sarah Johnson',
    company: 'TechStart Inc.',
    service: 'Trademark Registration',
    rating: 5,
    text: 'Exceptional service! The team handled our trademark registration with utmost professionalism. The process was smooth and completed faster than expected.',
    image: 'https://images.unsplash.com/photo-1581065178047-8ee15951ede6?w=400'
  },
  {
    name: 'Michael Chen',
    company: 'Creative Studios',
    service: 'Copyright Registration',
    rating: 4.5,
    text: 'I was impressed by their attention to detail and expertise. They made copyright registration straightforward and hassle-free. Highly recommended!',
    image: 'https://images.unsplash.com/photo-1642257859842-c95f9fa8121d?w=400'
  },
  {
    name: 'Emily Rodriguez',
    company: 'Fashion Forward LLC',
    service: 'Amazon Brand Registry',
    rating: 5,
    text: 'Outstanding support for Amazon Brand Registry! They helped us protect our brand and navigate the entire process seamlessly.',
    image: 'https://images.unsplash.com/photo-1627161683077-e34782c24d81?w=400'
  },
  {
    name: 'David Thompson',
    company: 'Startup Ventures',
    service: 'Company Formation',
    rating: 4.5,
    text: 'Professional and efficient! They handled all aspects of our company formation, allowing us to focus on building our business.',
    image: 'https://images.unsplash.com/photo-1762522927402-f390672558d8?w=400'
  },
  {
    name: 'Lisa Martinez',
    company: 'Artisan Goods Co.',
    service: 'Trademark Search',
    rating: 5,
    text: 'The comprehensive trademark search saved us from potential legal issues. Their thorough analysis gave us confidence in our brand choice.',
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400'
  }
];

export const faqs = [
  {
    question: 'How long does trademark registration take?',
    answer: 'The trademark registration process typically takes 8-12 months from filing to registration. However, you receive a filing date immediately, which provides legal protection.'
  },
  {
    question: 'What is included in the $45 trademark registration offer?',
    answer: 'Our $45 offer includes a comprehensive trademark search, application preparation, and filing with the USPTO. This is our promotional rate for the basic filing fee, with attorney review available as an add-on.'
  },
  {
    question: 'Do I need a trademark search before registration?',
    answer: 'Yes, we highly recommend a trademark search to ensure your mark is available and to avoid potential conflicts with existing trademarks. This can save you time and money in the long run.'
  },
  {
    question: 'What is the difference between trademark and copyright?',
    answer: 'A trademark protects brand names, logos, and slogans used in commerce, while copyright protects original creative works like books, music, and artwork. Both are important forms of intellectual property protection.'
  },
  {
    question: 'Can you help with international trademark registration?',
    answer: 'Yes, we provide assistance with international trademark registration through the Madrid Protocol and direct filing in foreign countries. Contact us to discuss your specific needs.'
  }
];

export const stats = [
  {
    number: '10,000+',
    label: 'Trademarks Registered',
    description: 'Successfully registered and protected for businesses nationwide'
  },
  {
    number: '98%',
    label: 'Success Rate',
    description: 'Of our trademark applications are approved by the USPTO'
  },
  {
    number: '15+',
    label: 'Years of Experience',
    description: 'Providing expert trademark and legal services'
  }
];

export const usps = [
  {
    title: 'Expert Legal Team',
    description: 'Our experienced attorneys and legal professionals ensure your application meets all USPTO requirements, maximizing approval chances.'
  },
  {
    title: 'Fast & Affordable',
    description: 'We offer competitive pricing starting at just $45 for trademark registration, with quick turnaround times and transparent pricing.'
  },
  {
    title: 'Full-Service Support',
    description: 'From initial search to registration and renewal, we provide comprehensive support throughout the entire process and beyond.'
  }
];